export const skinNameNormalize = (params: { skin: string; shortName: string }): string => {
  return `${params.shortName.replace(/\s/g, '_').trim()}__${params.skin.replace(/\s/g, '_').trim()}`;
};
